/**
 * Created by ivo on 11.08.14.
 */
define([],
    function() {
        /**
         * Flyout Component
         * @constructor
         */
        var FlyoutRegistry = function () {
            // Singleton
            if (typeof FlyoutRegistry.instance === 'object') {
                return FlyoutRegistry.instance;
            }

            // Cache for singleton
            FlyoutRegistry.instance = this;
        };

        /**
         * Add functions
         * @type {{}}
         */
        FlyoutRegistry.prototype = {
            /**
             * An array of all flyout components
             */
            _flyouts: [],

            /**
             * Adds a flyout to the registry
             * @param Flyout
             */
            add: function(flyout)
            {
                this._flyouts.push(flyout);
            },

            /**
             * Removes all flyouts from the registry, does NOT destroy the instances
             */
            clear: function()
            {
                this._flyouts = [];
            },

            /**
             * Returns all flyouts
             * @return Array
             */
            getAll: function()
            {
                return this._flyouts;
            }
        };

        return FlyoutRegistry;
    }
);


//////////////////
// WEBPACK FOOTER
// ./~/fcse-flyout/flyoutRegistry.js
// module id = 182
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21